import { ImageAndTextProps } from "@made-people/blueprint-image-and-text";

export const ImageAndText: ImageAndTextProps = {
  template: "template1",
  layout: {
    spacing: {
      y: {
        initial: "xl",
        md: "2xl",
        lg: "3xl",
      },
    },
  },
  media: {
    image: {
      displaySize: {
        mobile: "80vw",
        tablet: "30vw",
        desktop: "30vw",
      },
    },
  },
  variants: {
    layout: {
      initial: "vertical",
      lg: "horizontal",
    },
  },
  heading: {
    variants: {
      headingSize: {
        initial: "lg",
        lg: "lg",
      },
    },
  },
};
